import React, { FC } from "react";
import styled from "styled-components";
import { colors, colorNames } from "../../styles/variables";

const StyledSvg = styled.svg`
  fill: ${({ fill, theme }) =>
    fill || theme.color.primary || colors["darkGray"]};
  height: ${({ height = "16px" }) => height};
  width: ${({ width = "16px" }) => width};
`;

interface GiftSvgProps extends React.SVGProps<SVGSVGElement> {
  color?: colorNames;
}

export const GiftSvg: FC<GiftSvgProps> = ({
  color,
  className,
  ref,
  ...props
}) => {
  const fill = color && colors[color];

  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      {...props}
    >
      <path
        d="M29.3179 7.48306H26.4675C26.9859 6.6005 26.635 4.16752 26.1629 2.81416C24.6161 -1.53936 18.5199 3.19447 17.4639 4.09064C17.0081 3.7405 15.8822 3.90671 15.3414 3.86958C15.057 3.87078 14.7785 3.94718 14.5366 4.0904C13.4899 3.20042 7.38571 -1.53795 5.83954 2.80914C5.36723 4.16324 5.01308 6.59934 5.53368 7.48331H2.68202C2.23624 7.48379 1.80847 7.65335 1.49334 7.95511C1.17796 8.25664 1.0005 8.66594 1 9.09248V14.7649C1 15.0614 1.25105 15.3014 1.56067 15.3014H2.65945L2.6597 29.3905C2.6602 29.8173 2.83741 30.2263 3.15279 30.5281C3.46817 30.8296 3.89569 30.9994 4.34173 30.9999C7.32853 31.0001 27.6585 30.9999 27.6585 30.9999C28.1045 30.9994 28.5318 30.8296 28.8472 30.5281C29.1626 30.2263 29.3398 29.8173 29.3403 29.3905V15.3014H30.4393C30.7489 15.3014 31 15.0614 31 14.7649V9.09248C30.9995 8.66594 30.822 8.25664 30.5067 7.95511C30.1913 7.65335 29.7637 7.48354 29.3179 7.48306ZM18.9407 7.48306C20.3857 6.21161 23.8739 5.47325 25.5637 5.24425C25.6786 6.16029 25.6633 7.29649 24.9424 7.48306H18.9407ZM18.3801 14.2284C18.3385 14.2241 13.6607 14.2315 13.6199 14.2284V8.55599C13.6199 8.55599 17.9258 8.55671 18.3801 8.55599V14.2284ZM23.1773 2.09205C24.6786 1.7328 25.1784 3.03347 25.3679 4.18953C23.919 4.39119 20.2753 5.03807 18.2183 6.63042C18.2506 6.06761 18.2273 5.50335 18.1484 4.94512C19.6109 3.68513 21.3203 2.71545 23.1773 2.09205ZM15.3414 4.94273H16.6582C16.9005 4.94321 17.0965 5.13097 17.0967 5.36256V7.48329H14.9026V5.36256C14.9029 5.13098 15.0991 4.94321 15.3414 4.94273ZM6.91596 3.10722C7.02909 2.73098 7.29316 2.41294 7.65059 2.22251C8.00827 2.03235 8.43002 1.98541 8.82377 2.09199C10.6803 2.71539 12.389 3.68483 13.8513 4.94433C13.7767 5.50307 13.7534 6.06686 13.7812 6.62938C11.724 5.03771 8.08139 4.39107 6.63281 4.18942C6.71316 3.83377 6.80407 3.47098 6.91596 3.10722ZM6.43713 5.24419C8.19123 5.48201 11.4371 6.172 13.1011 7.48324H7.0581C6.33749 7.29668 6.32227 6.16029 6.43713 5.24419ZM2.121 9.09264C2.12151 8.79663 2.37231 8.55665 2.68167 8.55617H12.4982V14.2286C11.8256 14.2274 2.52405 14.2296 2.121 14.2286V9.09264ZM3.78071 29.3906V15.3015H13.2467L13.2465 29.9271H4.34113C4.03152 29.9266 3.78096 29.6867 3.78071 29.3906ZM14.3681 29.9271L14.3678 15.3015H17.6312V29.9271H14.3681ZM28.2188 29.3906C28.2186 29.6867 27.9675 29.9266 27.6579 29.9271H18.7526V15.3015H28.2186L28.2188 29.3906ZM29.8783 14.2286C29.5209 14.2308 20.1284 14.2272 19.5011 14.2286V8.55617H29.3176C29.627 8.55665 29.8775 8.79663 29.878 9.09264L29.8783 14.2286Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.5"
      />
    </StyledSvg>
  );
};
